import './Ujab_detail_download.scss';
import * as S from '../scss/theme';
import fnc from '../mymod/commFunction';
import fncS4 from '../mymod/commFunction4';  
import HongButton from '../comm/HongButton';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import imgDelete from '../images/svg/delete2.svg';
import { useSelector } from 'react-redux';

const Ujab_detail_download = ({ parentCode, setFileCnt, isVisible }) => {
  const isAdmin = useSelector((state => state.reduxIgong.isAdmin));
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [list, setList] = useState([]);
  //isVisible write에서만 가능
  useEffect(() => {
    fncSelect_list();
  }, []);

  function fncSelect_list() {
    fnc.sendAxios('/igongUjabRoutes/select/board_detail_fileDownload', { parentCode }, (res) => {
      if (res && Array.isArray(res)) {
        const newList = res.map(item => ({
          sno: item["sno"],
          parentCode: item["parentCode"],
          kind: item["kind"],
          fileCode: item["fileCode"],
          fileName: item["fileName"],
          code: item["code"],
          eDate: fnc.formatDate2(item["eDate"])
        }));
        setList(newList);
        setFileCnt(newList.length); // 파일 개수 업데이트
      } else {
        alert('검색에 실패했습니다.');
    
      }
    });
  }

  async function onClickDownload(item) { //여기는 사용 안 하는 듯 upload에 다운로드 있음
        
    const rtn = window.confirm('파일을 다운로드하시겠습니까?');
    if(!rtn) return null;
    const fileName = item.fileName;
    const fileCode = item.fileCode;

    const folder = 'upload/ujab'; // S3에 업로드할 폴더 경로
    const s3Key =`${folder}/${fileCode}`;

    let s3FilePath = await fncS4.getS3PathDownLoad_rename( s3Key, fileName);//c20250427072508415_ccc.zip => ccc.zip

    if (s3FilePath) {
    //   const link = document.createElement('a');
    //   link.href = s3FilePath; // S3의 직접 다운로드 링크
    //   link.setAttribute('download', fileName); // 다운로드할 파일 이름 설정(직업 다운로드 시 안 먹혀) blob은 웹뷰에서 안먹혀
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);

         window.open(s3FilePath, '_blank');//새로고침 돼서 이렇게 함

    } else {
      alert('S3 파일 경로가 올바르지 않습니다.');
    }
  }

  function onDeleteFile(item) {
    const rtn = window.confirm('파일을 삭제하시겠습니까?');
    if(!rtn) return null;
 
    fnc.sendAxios('/igongUjabRoutes/delete/board_detail_fileDownload',
         { code: item.code}, (res) => {
      if (res && res.success) {

        deleteS3File(item.fileCode);
        fncSelect_list(); // 파일 목록을 다시 불러옴
      } else {
        alert('파일 삭제에 실패했습니다.');
      }
    });
  }

    async function deleteS3File(fileCode) {
        const folder = 'upload/ujab';
        const s3Key = `${folder}/${fileCode}`;
        try {
            const res = await fncS4.deleteS3File(s3Key);
            return res && res.success;
        } catch (e) {
            return false;
        }
    }

//===========================================================
return (

        <div className='Ujab_detail_download'>
            {list.length > 0 && (
                <div className='frame_FileList'>    
                    <div className="FileList">  
                    <table>     
                    <tbody>
                        {list.map(item => (
                        <tr key={item.sno} onClick={() => onClickDownload(item)}>
                            <td>                      
                            <div className='fileName'>
                                    <i className="fas fa-paperclip"></i>
                                    {item.fileName}
                            </div>
                            </td>
                            <td>
                          {isVisible &&  <HongButton
                                    className="btn-delete"
                                    onClick={ (e) => { e.stopPropagation(); onDeleteFile(item); } }
                            >
                                    <img src={imgDelete} alt="삭제" style={{ width: 25, height: 25 }} />
                            </HongButton>}
                            </td>
                        </tr>
                        ))}
                    </tbody>
                    </table>
                    </div>
                </div>
            )}
        </div>

);
};

export default Ujab_detail_download;
